const projects = [
  {
    slug: 'midnight-director',
    title: 'midnight-director',
    shortDescription: 'Terminal TUI for coordinating multiple AI agents via tmux.',
    tags: ['Go', 'tmux', 'AI'],
    url: 'https://github.com/mlsvd/midnight-director',
    year: 2024,
    featured: true,
    order: 1,
    blocks: [
      {
        type: 'paragraph',
        text: 'midnight-director is a terminal UI built in Go for managing multiple tmux sessions running AI agents simultaneously. It provides a live dashboard to launch, monitor, and coordinate agents without leaving the terminal.',
      },
      {
        type: 'heading',
        level: 2,
        text: 'What it does',
      },
      {
        type: 'list',
        ordered: false,
        items: [
          'View all active tmux sessions in a live dashboard',
          'Launch new agents and create hierarchical session trees',
          'Send prompts to sessions and watch real-time execution',
          'Pipe output between sessions using placeholder syntax',
          'Generate AI summaries of completed runs',
          'Toggle between dark and light themes',
        ],
      },
      {
        type: 'heading',
        level: 2,
        text: 'Prompt system',
      },
      {
        type: 'paragraph',
        text: 'Load prompt templates from ~/.config/midnight-director/prompts.json with dynamic placeholders. For example, {{from:parent:10l}} injects the last 10 lines of a parent session\'s output into a child session\'s context, making it easy to chain agent workstreams.',
      },
      {
        type: 'heading',
        level: 2,
        text: 'Navigation',
      },
      {
        type: 'paragraph',
        text: 'Vim-style keybindings throughout: j/k to move, p for prompt picker, n for new session. Tmux integration shortcuts let you open the prompt picker (M-r) or return to midnight-director (M-b) from any active session.',
      },
      {
        type: 'heading',
        level: 2,
        text: 'Requirements',
      },
      {
        type: 'list',
        ordered: false,
        items: ['Go 1.21+', 'tmux'],
      },
    ],
  },
  {
    slug: 'quick-quick',
    title: 'quick-quick',
    shortDescription: 'Menu-driven shell script manager for the terminal.',
    tags: ['Bash'],
    url: 'https://github.com/mlsvd/quick-quick',
    year: 2023,
    featured: false,
    order: null,
    blocks: [
      {
        type: 'paragraph',
        text: 'quick-quick (qq) is a Bash utility that creates an organized, navigable system for managing and executing shell scripts. Instead of remembering paths or commands, you browse a menu and launch what you need.',
      },
      {
        type: 'heading',
        level: 2,
        text: 'How it works',
      },
      {
        type: 'paragraph',
        text: 'Scripts are organized in a hierarchical folder structure. Running qq opens a menu, graphical via the dialog utility or plain text as a fallback, that lets you navigate folders and pick a script to run.',
      },
      {
        type: 'heading',
        level: 2,
        text: 'Features',
      },
      {
        type: 'list',
        ordered: false,
        items: [
          'Hierarchical script organization with folder navigation',
          'Graphical menu via dialog, with text-based fallback',
          'Confirmation prompt before execution',
          'Customizable script directory',
          'Back-navigation between folder levels',
          'Minimal dependencies, Bash 4.0+ only',
        ],
      },
    ],
  },
  {
    slug: 'cd-plus',
    title: 'cd+',
    shortDescription: 'Bookmarked directory navigation for the shell.',
    tags: ['Bash'],
    url: 'https://github.com/mlsvd/cd_plus',
    year: 2023,
    featured: false,
    order: null,
    blocks: [
      {
        type: 'paragraph',
        text: 'cd+ enhances shell navigation by letting you bookmark frequently visited directories and jump to them instantly with a short alias, no more typing long paths.',
      },
      {
        type: 'heading',
        level: 2,
        text: 'Usage',
      },
      {
        type: 'list',
        ordered: false,
        items: [
          'cd+ save "shortcut": bookmark the current directory under a name',
          'cd+: open the bookmark menu and navigate to a saved directory',
        ],
      },
      {
        type: 'heading',
        level: 2,
        text: 'How it works',
      },
      {
        type: 'paragraph',
        text: 'Bookmarks are stored in ~/.cd_plus_bookmarks as pipe-delimited entries. The menu uses the dialog utility when available, falling back to bash\'s built-in select. Set it up with a shell alias so cd+ is always one keystroke away.',
      },
      {
        type: 'callout',
        text: 'Add alias cd+="source /path/to/cd_plus.sh" to your .bashrc to get started.',
      },
    ],
  },
];

export default projects;
